export default __webpack_public_path__ + "static/media/logo_VLX.02afcc90.svg";